module.exports = __webpack_public_path__ + "media/images/flags/nc-5a344b7b73fa1e4ff190da9a928e02de.png";